module.exports = __webpack_public_path__ + "images/avatars/male/10.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/10.svg
// module id = Nzyx
// module chunks = 55